import { render, staticRenderFns } from "./feed.vue?vue&type=template&id=a14750e2&"
import script from "./feed.vue?vue&type=script&lang=js&"
export * from "./feed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/opt/buildhome/repo/components/header/Header.vue').default,FooterMobile: require('/opt/buildhome/repo/components/footer-mobile/index.vue').default})
